import { gozokiApiWithAuth } from '../gozokiApi'

export type SensorAlertKind = 'OUT_OF_RANGE' | 'INACTIVE'

export type SensorAlertStatus = 'OPEN' | 'ACKNOWLEDGED' | 'RESOLVED'

export interface SensorAlertData {
  id: number
  sensorId: number
  sensorLabel: string
  equipmentLabel: string
  storeLabel: string
  kind: SensorAlertKind
  status: SensorAlertStatus
  openedAt: string
  metadata: Record<string, unknown> | null
}

export const fetchActiveAlerts = async () => {
  const response = await gozokiApiWithAuth.get<SensorAlertData[]>('/sensors/alerts')
  return response.data
}
